import React, { FC, useState } from "react";
import { Form } from "semantic-ui-react";
import Input from "@laborhack/input";
import Button from "@laborhack/custom-button";

import styles from "./styles.module.scss";
import { FieldValue } from "types";
import Joi from "@hapi/joi";
import RequestFailed from "_components/RequestFailed";
import firebase from "helpers/firebase";
import { useHistory } from "react-router-dom";
import { logEvent } from "../../../../helpers/analytics";

export interface EmailLinkSignInFormProps {}

export const EmailLinkSignInForm: FC<EmailLinkSignInFormProps> = ({}) => {
  const history = useHistory();

  const defaultField = {
    value: "",
    isValid: false,
  };

  const [email, setEmail] = useState<FieldValue<string>>(defaultField);
  const [submissionError, setSubmissionError] = useState(false);

  const handleSubmit = () => {
    logEvent("sign_in_with_email_link_clicked");
    const marketingTag = sessionStorage.getItem("marketing_tag");
    const actionCodeSettings = {
      url:
        window.location.origin +
        "/auth/finishSignIn" +
        (marketingTag ? `?marketing_tag=${marketingTag}` : ""),
      handleCodeInApp: true,
    };

    firebase
      .auth()
      .sendSignInLinkToEmail(email.value, actionCodeSettings)
      .then(() => {
        localStorage.setItem("login_email", email.value);
        history.push("/auth/checkEmail");
      })
      .catch((e) => {
        console.log(e);
        setSubmissionError(true);
      });
  };

  if (submissionError) {
    return (
      <RequestFailed
        onRetry={() => {
          setSubmissionError(false);
        }}
      />
    );
  }

  return (
    <Form>
      <Input
        autoComplete="email"
        type="email"
        value={email.value}
        textLabel="Email Address"
        onChange={(value: string, isValid: boolean) => {
          setEmail({ value, isValid });
        }}
        validate={{
          check: (value: string) => {
            return !Joi.string()
              .email({
                minDomainSegments: 2,
                tlds: { allow: false },
              })
              .validate(value).error;
          },
          message: "Invalid Email",
        }}
      />
      <Button
        disabled={!email.isValid}
        className={styles.continueButton}
        fullWidth
        onClick={handleSubmit}
      >
        Continue with Email
      </Button>
    </Form>
  );
};
